import React from 'react';
import { Navigate } from 'react-router-dom';

// The old marketing landing page has been replaced by /signup (SalesPage).
// But we must NOT unconditionally send everyone to /signup — the installed
// PWA on users' home screens has `start_url: "/"` baked into their local
// manifest (iOS bakes this at Add-to-Home-Screen time and never re-reads it).
// So an already-signed-in user tapping the icon needs to land in the app,
// not on the sales page. Fix: peek at the stored auth token and route
// authenticated users to /dashboard; everyone else still goes to /signup.
const LandingPage = () => {
  const hasToken = typeof window !== 'undefined' && !!localStorage.getItem('rxgrit_token');
  return <Navigate to={hasToken ? '/my-actions' : '/signup'} replace />;
};

export default LandingPage;
